import type {DitherParams} from '@github-ui/brand-webgl'

import type {DitherBrand} from '../types'

// Maps the Contentful `brand` enum to a dither color. Defaults to 'pearl'
// when no brand is set.
const BRAND_DITHER_COLOR: Record<DitherBrand, DitherParams['color']> = {
  Copilot: 'copilot',
  Security: 'security',
  Green: 'default',
}

/**
 * Returns the `WebGLDither` color for a given brand. Other dither params
 * (type, fadeIn, etc.) are intentionally left to each call site so the
 * Stacked hero, River stack, etc. can diverge as the design evolves.
 */
export function getBrandDitherColor(brand: DitherBrand | undefined): DitherParams['color'] {
  return brand ? BRAND_DITHER_COLOR[brand] : 'pearl'
}
